<template>
  <div class="col-lg-6">
    <h3 class="font-bold">{{ title }}</h3>
    <div class="m-t">
      {{ user.firstName + ' ' + user.lastName }}<br>
      {{ user.address.address }}
    </div>

    <component-document
      :ownerInformation="ownerInformation"
      :futureOwner="futureOwner"
      :command="command"
      :dataForValidationPopup="dataForValidationPopup"
      v-for="(doc, key) in userDocuments"
      v-bind:key="key"
      v-bind:document="doc"
      v-bind:subSection="true"
    />

  </div>
</template>

<script>
  import { addressToString } from '../../../helpers/utils'
  import Document from '@/components/details/documents/Document.vue'
  import gql from 'graphql-tag'

  export default {
    components: {
      'component-document': Document,
    },

    props: {
      title: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      user: {
        type: Object,
        required: true
      },
      userDocuments: {
        type: Array,
        required: true
      },
      ownerInformation: {
        type: Object
      },
      futureOwner: {
        type: Object
      },
      command: {
        type: Object,
        required: true
      }
    },

    computed: {
      dataForValidationPopup () {
        if (this.type === "owner") {
          return {
            owner: this.user
          }
        } else if (this.type === "coOwner") {
          return {
            coOwner: this.user
          }
        } else if (this.type === "futureOwner") {
          return {
            futureOwner: this.user
          }
        }
      }
    },

    mounted () {

    },

    methods: {

    }
  }
</script>